import { createReducer, Action, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter, Dictionary } from '@ngrx/entity';

import * as fromActions from '@core/core-store/departments-nested/departments-nested.actions';
import { Taxonomy } from '@app/core/models/taxonomy.model';

export interface State extends EntityState<Taxonomy> {}

export const adapter: EntityAdapter<Taxonomy> =
  createEntityAdapter<Taxonomy>({
    selectId: department => department.id
});

export const initialState: State = {
  ...adapter.getInitialState(),
};

const departmentsNestedReducer = createReducer(
  initialState,
  on(fromActions.departmentsNestedCollectionAddMany, (state, {departmentsNested}) => (
    adapter.addMany(departmentsNested, state)
  )),
);

export function reducer(state: State | undefined, action: Action) {
  return departmentsNestedReducer(state, action);
}

export const getIds = adapter.getSelectors().selectIds;
export const getEntities = adapter.getSelectors().selectEntities;
export const getAll = adapter.getSelectors().selectAll;
export const getTotal = adapter.getSelectors().selectTotal;

export const getEntityById = (entities: Dictionary<Taxonomy>, {id}) => entities[id];
export const getEntitiesById = (entities: Dictionary<Taxonomy>, {ids}) => ids.map(id => entities[id]);

